module.exports = __webpack_public_path__ + "static/tempus-symbol-DND3_FnP-0009428e9f9fa39ce6cea1dc4be9769d.webp";